import { ETFHoldingsBreakdownApiResponse, ETFHoldingsStandardApiResponse } from './types'

export const EFT_HOLDINGS_QUERY_KEY = 'etfHoldings'

export enum ETFHoldingsPollingIntervalInMs {
  Free = 43_200_000, // 12h
  Elite = 3_600_000, // 1h
  EliteStocksReduced = 21_600_000, // 6h
}

export const FALLBACK_BREAKDOWN_RESPONSE: ETFHoldingsBreakdownApiResponse = {
  rowData: [],
  etfTotalWeight: 0,
}

export const FALLBACK_STANDARD_RESPONSE: ETFHoldingsStandardApiResponse = {
  rowData: [],
  etfHoldingsTotal: 0,
  etfTotalWeight: 0,
}

export const NON_STOCK_INSTRUMENT_CATEGORIES = {
  // Bond: 'Fixed-Income Securities',
  Cash: 'Cash and Cash Equivalents',
  // Commodity: 'Alternative Investments',
  // CoveredWarrant: 'Derivatives',
  // DepositoryReceipt: 'Equities',
  // Derivative: 'Derivatives',
  // ExchangeTradedCommodity: 'Alternative Investments',
  // ExchangeTradedFund: 'Collective Investment Vehicles',
  // Fund: 'Collective Investment Vehicles',
  // Future: 'Derivatives',
  // Indices: 'Equities',
  MoneyMarket: 'Cash and Cash Equivalents',
  // Option: 'Derivatives',
  // PreferredShares: 'Equities',
  // StructuredProduct: 'Structured Products',
  // Swap: 'Derivatives',
  // Units: 'Collective Investment Vehicles',
  // Warrant: 'Derivatives',
}

export const WIDGET_BOX_STYLES =
  'relative ml-3 mt-3 flex max-h-85 min-h-85 min-w-152 max-w-175 shrink grow basis-0 flex-col overflow-hidden'
